import { useState } from "react";

/** Reddit CAPI: OAuth login lists advertisers, or manual pixel id + token. */
const useRedditDestination = () => {
    const [advertisers, setAdvertisers] = useState();
    const [partnerInstallId, setPartnerInstallId] = useState();
    const [selectedAdvertiser, setSelectedAdvertiser] = useState();
    const [advertiserSelectError, setAdvertiserSelectError] = useState();

    const handleLogin = (response) => {
        setAdvertisers(response?.data?.advertisers);
        setPartnerInstallId(response?.data?.partner_install_id);
    };

    const handleAdvertiserChange = (event) => {
        setSelectedAdvertiser(event.target.value);
        setAdvertiserSelectError(false);
    };

    const reset = () => {
        setAdvertisers(undefined);
        setPartnerInstallId(undefined);
        setSelectedAdvertiser(undefined);
        setAdvertiserSelectError(undefined);
    };

    return {
        reset,
        advertisers,
        partnerInstallId,
        selectedAdvertiser,
        advertiserSelectError,
        handleLogin,
        handleAdvertiserChange,
    };
};

export default useRedditDestination;
